function ApplicationList() {

}

ApplicationList.events = {
    isInit: true,
    isInitMoveTool: true,
    isInitConflictEvent: true,

    init: function() {
        var that = this;

        if (that.isInit) {
            // Remove Application
            $("#application-list-modal").on('click', '.remove-application-button', that.removeApplicationOnList);
            // Show location marker
            $("#application-list-modal").on('click', '.show-location-markers', that.onShowLocationMarker);
            // On click on application
            $("#application-list-modal").on('click', 'li.layer', that.onClickApplicationLayer);
            // Remove Application
            $("#modal-delete-confirmation").on("click", ".answer-yes", that.whenAnswerIsYes);

            that.isInit = false;
        }

        that.loadApplicationList();
        $("#application-list-modal .show-location-markers").html("");

        if (ub.showLocation) {
             $("#application-list-modal .show-location-markers").html("Hide location marker");
         } else {
             $("#application-list-modal .show-location-markers").html("Show location marker");
         }
    },

    initActivateMoveTool: function(data) {
        var that = this;
        if (that.isInitMoveTool) {
            $("#activate-location-marker-modal").on("click", ".am-application-item", that.activateMoveTool);
            that.isInitMoveTool = false;
        }

        that.loadActivateMoveTool(data);
    },

    initConflictEvent: function() {
        if (ApplicationList.events.isInitConflictEvent) {
            $("#application-list-with-conflict-modal").on("click", ".fix-color-btn", ApplicationList.events.onFixApplication)
            ApplicationList.events.isInitConflictEvent = false
        }
    },

    onFixApplication: function() {
        var code = $(this).data("application-code");
        var applicationSettings = ub.funcs.getApplicationSettings(code);

        if (typeof applicationSettings !== "undefined") {
            if (typeof applicationSettings.embellishment !== "undefined") {
                var embellishmentObject = applicationSettings.embellishment;

                
                Inksoft.funcs.checkColorConflict(embellishmentObject.design_details, function(hasConflict, colors) {
                    if (hasConflict) {
                        ub.data.isMessageIsCalled = true;
                        
                        ub.data.showConflictingColorList = true;
                        UIkit.modal("#application-list-with-conflict-modal").hide();
                        
                        Inksoft.funcs.launchDesignerWithColorConflict(embellishmentObject.design_id, applicationSettings.code, colors);
                    }
                });
            }
        }
    },

    activateMoveTool: function() {
        var code = $(this).data("code");
        var appObj = ub.funcs.getApplicationSettings(code);

        if (appObj.application_type === "team_name" ||  appObj.logo_type === "custom_text" || appObj.textLayoutType === "team_name" || appObj.isTailSweep) {
            var code = appObj.isTailSweep ? appObj.team_name_code : appObj.code
            if (!$('#property-modifiers-menu .menu-item-letters').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-letters').trigger('click');

                TeamNamePanel.funcs.initializeTeamName(code);
            }

        } else if (appObj.application_type === "player_name" || appObj.textLayoutType === "player_name") {

            if (!$('#property-modifiers-menu .menu-item-player').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-player').trigger('click');
            }

        } else if (appObj.logo_type === "custom" || appObj.logo_type === "stock") {

            if (!$('#property-modifiers-menu .menu-item-applications').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-applications').trigger('click')
            }
            
            _.delay(function() {
                $("#primary_options_container .logo-location-container .btn-selection-choice[data-perspective='" + appObj.application.views[0].perspective + "']").trigger("click");
            }, 500);
            
        } else if (appObj.application_type === "front_number" || appObj.application_type === "back_number" || appObj.application_type === "sleeve_number" || appObj.application_type === "number") {

            if (!$('#property-modifiers-menu .menu-item-numbers').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-numbers').trigger('click');
            }

            var locationBtnEl = $('#richardson-numbers-locations .location-buttons button[data-app-code="'+code+'"]');
            if (locationBtnEl.length > 0) {
                locationBtnEl.click();
            }
        }

        ub.funcs.activateMoveTool(appObj.code);
        UIkit.modal("#activate-location-marker-modal").hide();
    },

    loadActivateMoveTool: function(data) {
        var applications = [];
        
        if (_.size(data) > 0) {
            _.each(data, function(item) {
                var app = ub.funcs.getApplicationSettings(item);
                var application_type = "";
                if (typeof app !== "undefined") {
                    if (typeof app.isTailSweep !== "undefined" && app.isTailSweep) {
                        application_type = "TailSweep"
                    } else if (app.text_type === "text_shape") {
                        application_type = app.textLayoutType.replace("_", " ");
                    }  else if (app.application_type === "embellishments") {
                        application_type = app.logo_type + " logo";
                    } else {
                        application_type = app.application_type.replace("_", " ");
                    }

                    applications.push({
                        code: app.code,
                        caption: app.text_type === "text_shape" ? app.text : ub.funcs.getSampleCaption(app),
                        view: ub.funcs.getPrimaryView(app.application),
                        type: application_type
                    });
                }
            });

            data = {
                applications: applications
            };

            var render = ub.utilities.buildTemplateString('#m-application-tool-list', data);
            $("#activate-location-marker-modal .am-application-list").html("");
            $("#activate-location-marker-modal .am-application-list").html(render);

            UIkit.modal("#activate-location-marker-modal").show();
        }
    },

    whenAnswerIsYes: function() {
        var code = $(this).data("code");
        var appObj = ub.funcs.getApplicationSettings(code);
        var isNumbers = appObj.application_type === "front_number" || appObj.application_type === "back_number" || appObj.application_type === "sleeve_number" ? true : false;
        var tailsweep;

        if (appObj.application_type === "team_name") {
            tailsweep = TailSweep.funcs.getTailSweepSettings(appObj.code);
        }
        // Delete Location
        ub.funcs.deleteLocation(code);

        if (typeof tailsweep !== "undefined") {
            ub.funcs.deleteLocation(tailsweep.code);
        }

        if (appObj.application_type === "team_name" ||  appObj.logo_type === "custom_text" || appObj.textLayoutType === "team_name") {
            TeamNamePanel.funcs.loadAddTeamName();
        } else if (isNumbers) {
            ub.modifierController.numbers();
        } else if (appObj.logo_type === "custom" || appObj.logo_type === "stock") {
            ub.funcs.afterRemoveStockLogo(appObj);
        } else if (appObj.application_type === "player_name" ||  appObj.textLayoutType === "player_name") {
            PlayerNamePanel.funcs.loadAddPlayer();
        }

        $("#application-list-modal .application-list li.application-item-" + code).remove();
        UIkit.modal("#modal-delete-confirmation", {stack: true}).hide();
        ApplicationList.events.loadApplicationList();
    },

    loadApplicationList: function() {
        // Filter active
        var activeApplications = _.filter(ub.current_material.settings.applications, function(application) {
            if (ub.funcs.isTackleTwill()) {
                if (application.application_type === "free") {
                    return application
                }
            }
            
            if (typeof application.status === "undefined" || application.status === "on") {

                if (typeof application.isTailSweep === "undefined" || !application.isTailSweep) {
                    return application;
                }
            }
        });
        // Sort by zindex
        var _applicationCollection = _.sortBy(activeApplications, 'zIndex').reverse();

        var applicationObject = [];

        _.map(_applicationCollection, function(application) {
            var applicationType = "";

            if (application.application_type === "embellishments" || application.application_type === "mascot" ) {
                applicationType = "LOGO";
            } else {
                applicationType = application.application_type.toUpperCase().replace('_', ' ')
            }

            var view = ub.funcs.getPrimaryView(application.application);
                view = (ub.config.sport === "PTS Sock") && view === "right" ? "inside" : view;
                view = (ub.config.sport === "PTS Sock") && view === "left" ? "outside" : view;

            if (application.text_type === "text_shape") {
                var item = {
                    zindex: application.zIndex,
                    code: application.code,
                    caption: application.text,
                    view: view,
                    application_type: application.textLayoutType.replace("_", " "),
                    type: application.text_type
                }

            } else {
                var item = {
                    zindex: application.zIndex,
                    code: application.code,
                    caption: ub.funcs.getSampleCaption(application),
                    view: view,
                    application_type: applicationType,
                    type: application.application_type
                }
            }

            applicationObject.push(item);
        });

        data = {
            applications: applicationObject
        };

        var applicationListUI = ub.utilities.buildTemplateString('#m-application-layer-list', data);

        $("#application-list-modal ul.application-list").html("")
        $("#application-list-modal ul.application-list").html(applicationListUI);

        ub.data.sorting = false;

        ub.sort = $("ul.application-list").sortable({
            handle: '.layer',
            animation: 150,
            onStart: function (evt) {
                ub.data.sorting = true;
                ub.data.justSorted = true;
            },
            onEnd: function (evt) {
                ub.data.sorting = false;
                ub.data.justSorted = true;

            },
            onUpdate: function (evt) {
                $.each($('li.layer'), function (key, value) {
                    var _length = _.size(ub.current_material.settings.applications);
                    var _index = _length - (key + 1);
                    var _locID = $(value).data('location-id');
                    var _app = ub.current_material.settings.applications[_locID];
                    _app.zIndex = _index;

                    $(this).find('li.zIndex').html(_index + 1);

                    if (_app.application_type === "free") {
                        return;
                    }

                    _.each(_app.application.views, function (view) {

                        var _obj = ub.objects[view.perspective + '_view']['objects_' + _locID];

                        if (_obj.zIndex !== 0) { // Skip changing zIndex if application is disabled
                            _obj.zIndex = -(ub.funcs.generateZindex('applications') + _index);
                        }
                    });
                });

                ub.updateLayersOrder(ub.front_view);
                ub.updateLayersOrder(ub.back_view);
                ub.updateLayersOrder(ub.left_view);
                ub.updateLayersOrder(ub.right_view);
            }
        });

        UIkit.modal("#application-list-modal").show();
    },

    loadApplicationConflict: function(applications) {
        var parentElement = "#application-list-with-conflict-modal .conflicting-colors-container";
        var itemTemplate = document.getElementById("conflicting-colors-item").innerHTML;
        var template = _.template(itemTemplate);

        $(parentElement).html("");
        $(parentElement).html(template({
            applications: applications
        }));

        ApplicationList.events.initConflictEvent();
        UIkit.modal("#application-list-with-conflict-modal").show();
    },

    reloadConflict: function() {
        var applicationWithConflict = ApplicationCore.utilities.getAllEmbellishments(true);
        var parentElement = "#application-list-with-conflict-modal .conflicting-colors-container";
        
        if (_.size(applicationWithConflict) > 0) {
            var itemTemplate = document.getElementById("conflicting-colors-item").innerHTML;
            var template = _.template(itemTemplate);
            
            $(parentElement).html("");
            $(parentElement).html(template({
                applications: applicationWithConflict
            }));
        } else {
            $(parentElement).html("");
            $(parentElement).html('<h6 class="uk-text-center abrade-ultra-italic uk-margin-top uk-text-success">Congratulations! All errors have been resolved.</h6>');
        }

        UIkit.modal("#application-list-with-conflict-modal").show();
    },

    removeApplicationOnList: function() {
        /* Act on the event */
        var code = $(this).data("application-id");
        UIkit.modal("#modal-delete-confirmation", {stack: true}).show();
        $("#modal-delete-confirmation .answer-yes").data({
            'code': code,
        });
    },

    onShowLocationMarker: function() {
        if (ub.showLocation) {
            ub.funcs.removeLocations();
        } else {
            ub.funcs.showLocations();
        }

        UIkit.modal("#application-list-modal").hide();
    },

    onClickApplicationLayer: function() {
        /* Act on the event */
        var code = $(this).data("location-id");
        var application_type = $(this).data("application-type");

        var appObj = ub.funcs.getApplicationSettings(code);

        if (appObj.application_type === "team_name" ||  appObj.logo_type === "custom_text" || appObj.textLayoutType === "team_name") {

            if (!$('#property-modifiers-menu .menu-item-letters').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-letters').trigger('click');
            }

        } else if (appObj.application_type === "player_name" || appObj.textLayoutType === "player_name") {

            if (!$('#property-modifiers-menu .menu-item-player').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-player').trigger('click');
            }

        } else if (appObj.logo_type === "custom" || appObj.logo_type === "stock") {

            if (!$('#property-modifiers-menu .menu-item-applications').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-applications').trigger('click')
            }
            
            _.delay(function() {
                $("#primary_options_container .logo-location-container .btn-selection-choice[data-perspective='" + appObj.application.views[0].perspective + "']").trigger("click");
            }, 500);
            
        } else if (appObj.application_type === "front_number" || appObj.application_type === "back_number" || appObj.application_type === "sleeve_number" || appObj.application_type === "number") {

            if (!$('#property-modifiers-menu .menu-item-numbers').hasClass("active")) {
                $('#property-modifiers-menu .menu-item-numbers').trigger('click');
            }
        }
    },
}